import React from "react"
import "./CSS/Faq.css"

const Faq = () => {
    return (
        <div className="faq">
            <h1>FAQ</h1>
            <hr />
            <div className="questions">
            <h2>01. How do I make a purchase?</h2>
            <p>
                To make a purchase, go to the website's 'order now' button and follow the on-screen instructions.
            </p>
            <hr />
            <h2>02. What methods of payment does BuyZone Online accept?</h2>
            <p>
            We have a wide range of payment options for you to choose from. Cash on Delivery (COD) is available throughout the island. Bank Payments / Online Bank Transfers / Payment Link or simply place an order on our website and pay with your VISA, Mastercard and Amercian Express cards.
            </p>
            <hr />
            <h2>03. Will BuyZone Online restock an item I wanted to purchase which is sold out?</h2>
            <p>
            Restocking a particular style is dependent on demand. If the style is frequently requested, we will refill it in a matter of weeks. If not, you can use the 'search' option to find a similar style or our team will gladly offer you similar designs through Facebook or Instagram.
            </p>
            <hr />
            <h2>04. Can I ship to more than one address?</h2>
            <p>
            Although you can enter a different address as the recipient's address, we only ship to one address in one delivery.
            </p>
            <hr />
            <h2>05. Can I change my delivery address?</h2>
            <p>
            If you wish to change your delivery address, please immediately contact us and we will do our best to assist you in this matter. In case we cannot change the address anymore, usually because the package has already been shipped, we will need to contact our courier to request a change of delivery address.
            </p>
            <hr />
            <h2>06. How long does it take for a delivery, and how much does it cost?</h2>
            <p>
            Our standard delivery time ranges from 2-5 business days. Orders are subject to the prices listed on the product page at the time of purchase. Taxes are not included in these pricing; the entire price (including taxes) is shown on the shopping basket page. We accept a variety of credit cards, including Visa, American Express, and Mastercard, and will charge your credit card for the invoice as soon as the item has been accepted and shipped. International Shipping varies from location to location. Please inquire before make the purchase.
            </p>
            <hr />
            <h2>07. What is the time limit for a return notice?</h2>
            <p>
            Exchange/return must be made within 14 days from the purchased date. The garment should be in its original condition in order to be exchanged, it will only be accepted with its receipt and BuyZone Onlinetags attached. For more information you can refer to our ‘Exchange Policy’ on the website.
            </p>
            <hr />
            <h2>08. Is it possible to amend or change my order once it has been placed?</h2>
            <p>
            Once an order is submitted, we are unable to change the ordered products or the quantity selected. In this situation, we suggest you contact us within 10- 25 minutes and you may only propose adjustments or cancel the incorrect order if your package is not yet dispatched from our warehouse. If not, we recommend you cancel the incorrect order and place a new order for your desired item(s) on our website at your own convenience.
            </p>
            </div>
            <br />
            <br />
            <br />
            <br />
        </div>
    )

}

export default Faq

